import { Image, Modal, Spin, message } from "antd";
import React, { useEffect, useState } from "react";
import { svg } from "../../../../../Assets/svg";
import {
  capitalizeFirstLetter,
  CapitalizeFirstWord,
  DefaultNoImageFound,
  getThumbnailUrl,
  momentDateTime,
  momentFullTime,
  momentDDMMYY,
} from "../../../../../helpers/utils";
import {
  DeleteOrderProductionLogAPI,
  GetManufacturingProductsListAPI,
  GetOrderProductionLogsAPI,
  GetOrdersProductionPlanAPI,
  AddOrderProductionLogAPI,
  GetProductionJobQualityChecklistsAPI,
} from "../../../../Redux/orders";
import FillQualityChecklistModal from "../../../Manufacturing/Components/FillQualityChecklistModal";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import dayjs from "dayjs";
import {
  ProductFinishEnum,
  ProductFinishLabels,
} from "../../../Products/productsTypes";
import { PoductStartEditArray } from "../../orderTypes";
import { decryptByText } from "../../../../../helpers/bycrypt";
import InfiniteScroll from "react-infinite-scroll-component";
import CommonDeleteModal from "../../../../Components/Modals/CommonDeleteModal";
import AddOrderProductionQtyModal from "../../../Manufacturing/Components/AddOrderProductionQtyModal";
import FullScreenLoader from "../../../../Components/FullScreenLoader";
import { CommonConfirmationModal } from "../../../../../Components/CommonConfirmationModal";

const ProductionLogModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  productionId: any;
  splitsId: any;
  today_date: any;
  is_available_qty:any
}> = ({
  visible,
  setIsModalVisible,
  onClose,
  productionId,
  splitsId,
  today_date,
  is_available_qty
}) => {
  const dispatch = useAppDispatch();
  const payload = {
    _id: productionId,
    splits_id: splitsId,
    today_date: today_date,
    is_available_qty:is_available_qty
  };
  const { manufacturingProductsDetails, manufacturingProductionLogs } =
    useAppSelector((state: RootState) => state.orders);

  const { getManufacturingProductsLoading, deleteOrderProductionLogLoading } =
    useAppSelector((state: RootState) => state?.loading);
  const [openAddQtyModal, setOpenAddQtyModal] = useState(false);
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [deleteLogModalVisible, setDeleteLogModalVisible] = useState(false);
  const [logToDelete, setLogToDelete] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [rerenderLog, setRerenderLog] = useState(1);
  const [openResetConfirmModal, setOpenResetConfirmModal] = useState<boolean>(false);
  const [updatingStatus, setUpdatingStatus] = useState<string | null>(null);
  const [showChecklistModal, setShowChecklistModal] = useState(false);
  const [checklistQuestions, setChecklistQuestions] = useState<any[]>([]);
  const [currentChecklistId, setCurrentChecklistId] = useState<string | null>(null);
  const [pendingCompleteInfo, setPendingCompleteInfo] = useState<any>(null);

  const limit = 10;

  const executeProductionLog = (
    info: any,
    status: "started" | "completed" | "scheduled",
    quality_checklists?: any,
  ) => {
    const apiPayload: any = {
      order_id: info.order_id,
      production_planning_id: info.production_planning_id,
      splits_id: info.splits_id,
      status: status,
    };

    if (status === "completed") {
      apiPayload.manufactured_qty = info.available_qty;
    }

    if (info.machine_id) apiPayload.machine_id = info.machine_id;
    if (info.department_id) apiPayload.department_id = info.department_id;
    if (quality_checklists) apiPayload.quality_checklists = quality_checklists;

    const handleCallback = (success?: boolean) => {
      setUpdatingStatus(null);
      setOpenResetConfirmModal(false);
      if (success) {
        message.success(
          `Production ${
            status === "started"
              ? "started"
              : status === "scheduled"
              ? "reset to scheduled"
              : "completed"
          } successfully!`,
        );
        dispatch(GetManufacturingProductsListAPI(payload, true));
        setRerenderLog((prev: number) => prev + 1);
        setCurrentPage(1);
      }
    };

    dispatch(AddOrderProductionLogAPI(apiPayload, handleCallback));
  };

  const handleStartOrCompleteProduction = (
    targetStatus: "started" | "completed" | "scheduled",
  ) => {
    if (!manufacturingProductsDetails) return;

    setUpdatingStatus(targetStatus);

    const itemsData = manufacturingProductsDetails;
    const splitData = itemsData?.items?.splits;
    const splitId = splitData?._id || splitsId;

    const orderId =
      itemsData?.order?._id || itemsData?.order_id || itemsData?.order;
    const productionPlanningId =
      itemsData?._id ||
      itemsData?.production_planning_id ||
      itemsData?.planning_id ||
      productionId;

    const machineId =
      splitData?.machine_id?._id || splitData?.machine_id || null;
    const departmentId =
      splitData?.department_id?._id || splitData?.department_id || null;

    const availableQty =
      splitData?.available_to_manufacture_qty !== undefined &&
      splitData?.available_to_manufacture_qty !== null
        ? splitData?.available_to_manufacture_qty
        : splitData?.pending_qty !== undefined &&
          splitData?.pending_qty !== null
        ? splitData?.pending_qty
        : splitData?.qty || 1;

    const completeInfo = {
      order_id: orderId,
      production_planning_id: productionPlanningId,
      splits_id: splitId,
      machine_id: machineId,
      department_id: departmentId,
      available_qty: availableQty,
    };

    if (targetStatus === "started" || targetStatus === "scheduled") {
      executeProductionLog(completeInfo, targetStatus);
      return;
    }

    // For "completed": Fetch quality checklist for full complete
    dispatch(
      GetProductionJobQualityChecklistsAPI({ job_id: splitId }, (data: any) => {
        const targetQc =
          data?.quality_checklists?.find(
            (q: any) => q.full_complete === true || q.half_complete === false,
          ) || data?.quality_checklists?.[0];

        if (targetQc && targetQc.checklist_id?.questions?.length > 0) {
          setPendingCompleteInfo(completeInfo);
          setChecklistQuestions(targetQc.checklist_id.questions);
          setCurrentChecklistId(targetQc.checklist_id._id);
          setShowChecklistModal(true);
        } else {
          executeProductionLog(completeInfo, "completed");
        }
      }),
    );
  };

  const handleSaveChecklistAnswers = (checklistAnswers: any) => {
    if (!pendingCompleteInfo) return;

    let quality_checklists: any = undefined;
    if (checklistAnswers && checklistQuestions?.length > 0) {
      const formattedAnswers = checklistQuestions.map((q: any) => {
        const entry = checklistAnswers[q._id] || {};
        const isQAnswered =
          entry.answer !== null &&
          entry.answer !== undefined &&
          entry.answer !== "";
        return {
          question_id: q._id,
          question_text: q.question_text || "",
          ans_type: q.ans_type || entry.ans_type,
          answer: entry.answer,
          conditional_answer: entry.conditional_answer,
          photo: entry.photo || [],
          photo_required: q.photo_required || false,
          if_yes_action: q.if_yes_action || null,
          if_no_action: q.if_no_action || null,
          is_answered:
            entry.is_answered !== undefined ? entry.is_answered : isQAnswered,
        };
      });

      quality_checklists = [
        {
          checklist_id: currentChecklistId,
          half_complete: false,
          full_complete: true,
          department_id: pendingCompleteInfo.department_id,
          questions_data: formattedAnswers,
        },
      ];
    }

    executeProductionLog(pendingCompleteInfo, "completed", quality_checklists);
    setShowChecklistModal(false);
    setPendingCompleteInfo(null);
  };

  const isCurrentDataLoaded = Boolean(
    manufacturingProductsDetails &&
      (splitsId
        ? String(manufacturingProductsDetails?.items?.splits?._id) ===
          String(splitsId)
        : String(manufacturingProductsDetails?._id) === String(productionId)),
  );

  useEffect(() => {
    dispatch({ type: "GET_MANUFACTURING_PRODUCTS_DETAILS", payload: null });
    dispatch({
      type: "GET_MANUFACTURING_PRODUCTION_LOGS",
      payload: { data: [], page: 1 },
    });
    if (productionId || splitsId) {
      dispatch(GetManufacturingProductsListAPI(payload, true));
    }
    return () => {
      dispatch({ type: "GET_MANUFACTURING_PRODUCTS_DETAILS", payload: null });
      dispatch({
        type: "GET_MANUFACTURING_PRODUCTION_LOGS",
        payload: { data: [], page: 1 },
      });
    };
  }, [productionId, splitsId]);

  useEffect(() => {
    if (splitsId) {
      dispatch(
        GetOrderProductionLogsAPI(
          { splits_id: splitsId, page: currentPage, limit },
          setHasMore,
        ),
      );
    }
  }, [currentPage, rerenderLog, splitsId]);

  const showStatus = (recordValue: any) => {
    const statusClassMap = {
      started: "designPendingStatus",
      completed: "approvedStatus",
      scheduled: "draftStatus",
    };

    const displayLabel =
      recordValue === "init"
        ? ""
        : recordValue === "started"
        ? "Started"
        : recordValue === "completed"
        ? "Completed"
        : "Scheduled";
    return (
      <span
        className={`d-inline-flex fs-4 align-items-center billStatus ${
          statusClassMap[recordValue as keyof typeof statusClassMap] || ""
        }`}
      >
        {svg.dotIcon}
        {displayLabel}
      </span>
    );
  };

  return (
    <Modal
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Production Log History
        </div>
      }
      visible={visible}
      destroyOnClose={true}
      onCancel={onClose}
      width={"80rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        {getManufacturingProductsLoading || !isCurrentDataLoaded ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "500px" }}
          >
            <FullScreenLoader />
          </div>
        ) : (
          <>
            <div className="card border-0 shadow rounded-4 mb-3">
              <div className="card-body row gy-3">
                <div
                  className="col-md-5 d-flex flex-column gap-3"
                  style={{ borderRight: "#949494 1px solid" }}
                >
                  <div className="d-flex align-items-start gap-2">
                    <div className="img-55 rounded-2 overflow-hidden">
                      <Image
                        // 1. Thumbnail for the table view
                        src={
                          manufacturingProductsDetails?.items?.product
                            ?.pre_galvanised_image
                            ? getThumbnailUrl(
                                manufacturingProductsDetails?.items?.product
                                  ?.pre_galvanised_image,
                              )
                            : DefaultNoImageFound
                        }
                        // 2. Full-size image for the preview modal
                        preview={false}
                        // 3. Native fallback prop (cleaner than onError)
                        fallback={DefaultNoImageFound}
                        alt={
                          manufacturingProductsDetails?.items?.splits
                            ?.variant_id?.variant_name
                        }
                        rootClassName="w-100 h-100"
                        className="w-100 h-100 object-fit-cover"
                        onClick={(e: any) => {
                          e.stopPropagation();
                        }}
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center flex-wrap gap-2">
                        <p
                          className="p-0 m-0 fs-5 fw-bold"
                          style={{
                            color:
                              manufacturingProductsDetails?.items?.item_type ==
                              "bom_part"
                                ? "#EA7E58"
                                : manufacturingProductsDetails?.items
                                    ?.item_type == "component"
                                ? "#A756AC"
                                : "#58BF6E",
                          }}
                        >
                          {manufacturingProductsDetails?.items?.item_type ===
                          "bom_part"
                            ? "Part"
                            : manufacturingProductsDetails?.items?.item_type ===
                              "component"
                            ? "Component"
                            : manufacturingProductsDetails?.items?.item_type ===
                              "advertisement_sign"
                              ? "Advertisement Sign"
                              : "Variant"}
                        </p>

                        {manufacturingProductsDetails?.order?.order_id && (
                          <span className="badge bg-light text-dark border fs-6 fw-semibold text-nowrap flex-shrink-0">
                            {/* Order:  */}
                            {manufacturingProductsDetails?.order?.order_id}
                          </span>
                        )}

                        {(manufacturingProductsDetails?.order?.customer_name ||
                          manufacturingProductsDetails?.order?.customer?.full_name ||
                          manufacturingProductsDetails?.order?.company_name ||
                          manufacturingProductsDetails?.order?.customer?.first_name) && (
                          <span
                            className="badge bg-light text-primary border fs-6 fw-semibold text-wrap text-start mw-100"
                            style={{
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {/* Customer:{" "} */}
                            {manufacturingProductsDetails?.order?.customer_name ||
                              manufacturingProductsDetails?.order?.customer?.full_name ||
                              manufacturingProductsDetails?.order?.customer?.first_name}
                            {manufacturingProductsDetails?.order?.company_name ||
                            manufacturingProductsDetails?.order?.customer?.company_name
                              ? ` (${manufacturingProductsDetails?.order?.company_name || manufacturingProductsDetails?.order?.customer?.company_name})`
                              : ""}
                          </span>
                        )}
                      </div>
                      <p
                        className="fs-5 fw-bold mb-0 text-break"
                        style={{ wordBreak: "break-word" }}
                      >
                        {["bom_part", "component", "advertisement_sign"].includes(
                          manufacturingProductsDetails?.items?.item_type,
                        )
                          ? manufacturingProductsDetails?.items?.name
                          : manufacturingProductsDetails?.items?.splits
                              ?.variant_id?.variant_name
                          ? `${manufacturingProductsDetails?.items?.splits?.variant_id?.variant_name}`
                          : "-"}
                      </p>
                      <p
                        className="fs-6 mb-0"
                        style={{
                          color:
                            manufacturingProductsDetails?.items?.splits?.status ===
                            "completed"
                              ? "#419f20"
                              : "inherit",
                        }}
                      >
                        {manufacturingProductsDetails?.items?.product
                          ?.labelInQuotation || "Qty"}{" "}
                        - {manufacturingProductsDetails?.items?.quantity}
                      </p>
                    </div>
                  </div>
                  <div className="d-flex gap-3 flex-wrap">
                    <div className="d-flex flex-wrap gap-2">
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.height ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Height:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.height
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.reinforced_height ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Reinforced Height:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.reinforced_height
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.width ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Width:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.width
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.depth ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Depth:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.depth
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.length ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Length:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.length
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}

                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.thickness ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Thickness:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.thickness
                            }
                            mm
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.finish ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Finish:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              ProductFinishLabels[
                                manufacturingProductsDetails?.items?.splits
                                  ?.variant_id?.finish as ProductFinishEnum
                              ]
                            }
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.color ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Color:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.color
                            }
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {manufacturingProductsDetails?.items?.splits?.variant_id
                        ?.bolts_per_footplate ? (
                        <div className="card p-3 py-1">
                          <p className="text-muted d-block fw-normal mb-0 fs-7">
                            Bolts Per Footplate:
                          </p>
                          <span className="fw-bold fs-5">
                            {
                              manufacturingProductsDetails?.items?.splits
                                ?.variant_id?.bolts_per_footplate
                            }
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-7 d-flex">
                  <div className="d-flex flex-column justify-content-center gap-3">
                    <div className="d-flex flex-wrap align-items-center gap-3">
                      <div className="">
                        <p className="text-muted d-block fw-normal mb-0 fs-5">
                          Start Date
                        </p>
                        <span className="fw-bold fs-4">
                          {manufacturingProductsDetails?.items?.splits?.start_at
                            ? momentDDMMYY(
                                manufacturingProductsDetails?.items?.splits
                                  ?.start_at,
                              )
                            : "-"}
                        </span>
                      </div>
                      <div className="">
                        <p className="text-muted d-block fw-normal mb-0 fs-5">
                          End Date
                        </p>
                        <span className="fw-bold fs-4">
                          {manufacturingProductsDetails?.items?.splits?.end_at
                            ? momentDDMMYY(
                                manufacturingProductsDetails?.items?.splits
                                  ?.end_at,
                              )
                            : "-"}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      <div className="">
                        <p className="text-muted d-block fw-normal mb-0 fs-4">
                          Manufacturing Status
                        </p>
                        <span className="fw-bold fs-2">
                          {manufacturingProductsDetails?.items?.splits?.status
                            ? showStatus(
                                manufacturingProductsDetails?.items?.splits
                                  ?.status,
                              )
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="fs-1 fw-bold mb-0">Created Product Log</h2>
              {(() => {
                const currentStatus =
                  manufacturingProductsDetails?.items?.splits?.status;
                const isStarted = currentStatus === "started";
                const isCompleted = currentStatus === "completed";

                if (isCompleted) {
                  return null;
                }

                if (isStarted) {
                  return (
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="btn btn-primary btn-lg fs-4 fw-bold px-4 py-2"
                        disabled={!!updatingStatus}
                        onClick={() => setOpenResetConfirmModal(true)}
                      >
                        {updatingStatus === "scheduled" ? "Resetting..." : "RESET"}
                      </button>
                      <button
                        className="btn btn-lg text-white fs-4 fw-bold px-4 py-2"
                        style={{
                          backgroundColor: "#419f20",
                          borderColor: "#419f20",
                        }}
                        disabled={!!updatingStatus}
                        onClick={() =>
                          handleStartOrCompleteProduction("completed")
                        }
                      >
                        {updatingStatus === "completed" ? "Updating..." : "COMPLETE"}
                      </button>
                    </div>
                  );
                }

                return (
                  <button
                    className="btn btn-lg text-white fs-4 fw-bold px-4 py-2"
                    style={{ backgroundColor: "#000", borderColor: "#000" }}
                    disabled={!!updatingStatus}
                    onClick={() => handleStartOrCompleteProduction("started")}
                  >
                    {updatingStatus === "started" ? "Starting..." : "START"}
                  </button>
                );
              })()}
            </div>
            <InfiniteScroll
              dataLength={manufacturingProductionLogs?.length}
              next={() => setCurrentPage((prev) => prev + 1)}
              hasMore={hasMore}
              loader={<div className="text-center p-2">{/* <Spin /> */}</div>}
              scrollableTarget="scrollableDiv"
              endMessage={
                currentPage > 1 ? (
                  <div className="text-center p-2 text-muted fs-7">
                    No more logs to display
                  </div>
                ) : (
                  ""
                )
              }
            >
              {manufacturingProductionLogs?.length > 0
                ? manufacturingProductionLogs?.map((elem: any) => {
                    return (
                      <div className="card border-0 rounded-4 cursor-pointer mb-3 p-3">
                        <div className="row gy-3 mx-0">
                          <div
                            className={`${
                              PoductStartEditArray.includes(
                                manufacturingProductsDetails?.order?.status,
                              )
                                ? "col-md-9"
                                : "col-md-12"
                            } d-flex flex-column gap-3`}
                          >
                            <div className="d-flex gap-3 flex-wrap">
                              <div className="">
                                <p className="text-muted d-block fw-normal mb-0 fs-5">
                                  Machine
                                </p>
                                <span className="fw-bold fs-4">
                                  {elem?.machine_id?.name
                                    ? elem?.machine_id?.name
                                    : "-"}
                                </span>
                              </div>
                              <div className="">
                                <p className="text-muted d-block fw-normal mb-0 fs-5">
                                  Employee
                                </p>
                                <span className="fw-bold fs-4">
                                  {`${CapitalizeFirstWord(
                                    decryptByText(
                                      elem?.team_member?.first_name,
                                    ) +
                                      " " +
                                      decryptByText(
                                        elem?.team_member?.last_name,
                                      ),
                                  )}`}
                                </span>
                              </div>
                              <div className="">
                                <p className="text-muted d-block fw-normal mb-0 fs-5">
                                  Added Date
                                </p>
                                <span className="fw-bold fs-4">
                                  {elem?.created_at
                                    ? momentDDMMYY(elem?.created_at)
                                    : "-"}
                                </span>
                              </div>
                              <div className="">
                                <p className="text-muted d-block fw-normal mb-0 fs-5">
                                  Manufactured Qty
                                </p>
                                <span className="fw-bold fs-4">
                                  {elem?.manufactured_qty}
                                </span>
                                <div
                                  className="text-muted d-block fw-normal mb-0"
                                  style={{ fontSize: "10px" }}
                                >
                                  (
                                  {manufacturingProductsDetails?.items?.product
                                    ?.labelInQuotation || "Qty"}
                                  )
                                </div>
                              </div>
                            </div>
                          </div>
                          {PoductStartEditArray.includes(
                            manufacturingProductsDetails?.order?.status,
                          ) ? (
                            <div className="col-md-3">
                              <div className="d-flex justify-content-end align-items-center h-100 gap-2">
                                {/* <div
                                  className="svg-100"
                                  onClick={() => {
                                    setSelectedLog(elem);
                                    setOpenAddQtyModal(true);
                                  }}
                                >
                                  {svg?.tableEditIcon}
                                </div> */}
                                <div
                                  className="svg-100"
                                  onClick={() => {
                                    setLogToDelete(elem);
                                    setDeleteLogModalVisible(true);
                                  }}
                                >
                                  {svg?.tableDeleteIcon}
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })
                : ""}
            </InfiniteScroll>
            {!getManufacturingProductsLoading &&
            manufacturingProductionLogs?.length == 0 ? (
              <div
                className="fs-3 w-100 text-949494 d-flex align-items-center justify-content-center"
                style={{ height: "30%" }}
              >
                No Log Found!
              </div>
            ) : (
              ""
            )}
          </>
        )}
        {openAddQtyModal && (
          <AddOrderProductionQtyModal
            visible={openAddQtyModal}
            setIsModalVisible={(val: boolean) => {
              setOpenAddQtyModal(val);
              if (!val) {
                setSelectedLog(null);
                setCurrentPage(1);
              }
            }}
            details={manufacturingProductsDetails}
            selectedLog={selectedLog}
            isDetailsPage={true}
            users={manufacturingProductsDetails?.items?.splits?.employee_details?.map(
              (elem: any) => {
                const name = `${capitalizeFirstLetter(
                  decryptByText(elem?.first_name),
                )} ${capitalizeFirstLetter(decryptByText(elem?.last_name))}`;
                return {
                  label: name,
                  value: elem?._id,
                };
              },
            )}
            setRerenderLog={setRerenderLog}
            setCurrentPage={setCurrentPage}
          />
        )}

        {deleteLogModalVisible && (
          <CommonDeleteModal
            visible={deleteLogModalVisible}
            setIsModalVisible={setDeleteLogModalVisible}
            title="Delete Production Log"
            description="Are you sure you want to delete this production log? This will revert the manufactured quantity."
            handleDelete={() => {
              if (logToDelete?._id) {
                dispatch(
                  DeleteOrderProductionLogAPI(
                    {
                      log_id: logToDelete._id,
                      department_id:
                        manufacturingProductsDetails?.items?.splits
                          ?.department_id,
                    },
                    () => {
                      dispatch({
                        type: "ADDED_LOG_FROM_PRODUCTION",
                        payload: {
                          qty: -Math.abs(logToDelete?.manufactured_qty),
                          id: manufacturingProductsDetails?.items?.splits?._id,
                        },
                      });
                      setDeleteLogModalVisible(false);
                      setLogToDelete(null);
                      setCurrentPage(1);
                    },
                  ),
                );
              }
            }}
            isLoading={deleteOrderProductionLogLoading}
          />
        )}
        {showChecklistModal && (
          <FillQualityChecklistModal
            visible={showChecklistModal}
            checklistQuestions={checklistQuestions}
            setIsModalVisible={(val: boolean) => {
              setShowChecklistModal(val);
              if (!val) {
                setUpdatingStatus(null);
                setPendingCompleteInfo(null);
              }
            }}
            onOk={handleSaveChecklistAnswers}
            initialAnswers={{}}
            isHalfComplete={false}
          />
        )}
        {openResetConfirmModal && (
          <CommonConfirmationModal
            open={openResetConfirmModal}
            title="Reset Production, Are You Sure?"
            subTitle="Are you sure you want to reset this production status to scheduled?"
            loading={updatingStatus === "scheduled"}
            confirmButtonText="Reset"
            confirmButtonColorClass="btn-primary"
            onSuccess={() => handleStartOrCompleteProduction("scheduled")}
            onClose={() => setOpenResetConfirmModal(false)}
          />
        )}
      </div>
    </Modal>
  );
};

export default ProductionLogModal;
